import { render } from "./edit-client-structure-corporate.vue?vue&type=template&id=70b3c3f1"
import script from "./edit-client-structure-corporate.vue?vue&type=script&lang=js"
export * from "./edit-client-structure-corporate.vue?vue&type=script&lang=js"

import "./edit-client-structure-corporate.vue?vue&type=style&index=0&id=70b3c3f1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__